// export const UPDATE_STATUS            = "UPDATE_STATUS"           ;
export const UPDATE_OBJECT_CATEGORY   = "UPDATE_OBJECT_CATEGORY"  ;
export const UPDATE_STRING_FOR_SEARCH = "UPDATE_STRING_FOR_SEARCH";
export const CLEAR_EXTRACT_CONDITION  = "CLEAR_EXTRACT_CONDITION" ;
